//弹框toast
export const toast = (message, duration = 3000) => {
    // 创建div元素
    const toastElement = document.createElement('div');
    toastElement.innerText = message;
    toastElement.style.cssText = `
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      background-color: black;
      color: white;
      padding: 0.2rem;
      border-radius: 0.1rem;
      opacity: 0;
      font-size:0.24rem;
      z-index:10000;
    `;
    
    // 将div元素添加到body中
    document.body.appendChild(toastElement);
    
    // 显示toast
    toastElement.style.opacity = 1;
    
    // 定时器用于隐藏toast
    setTimeout(() => {
      toastElement.style.opacity = 0;
      setTimeout(() => {
        document.body.removeChild(toastElement);
      }, 500); // 0.5秒后移除元素
    }, duration);
  }

//防抖
export function debounce(fn, delay) {
	let timeout;
	return  (...args)=> {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			fn.apply(this, args);
		}, delay);
	};
}

export function throttle(func, wait) {
  let lastTime = 0;
  return function(...args) {
    const now = Date.now();
    if (now - lastTime >= wait) {
      lastTime = now;
      func.apply(this, args);
    }
  };
}

//滚动到底部事件
export function scrollFn(callback, bottomHeight=100) {
    // 获取页面的高度
    var pageHeight = document.body.scrollHeight;
    // 获取可视区域的高度
    var viewportHeight = window.innerHeight;
    // 获取当前滚动位置
    var scrollPosition = window.scrollY;
    // 当用户滚动到距离底部不远的位置时（例如100px），加载更多数据
    if (pageHeight - (scrollPosition + viewportHeight) < bottomHeight) {
        // 加载数据的函数
        callback();
    }
}


// WEBPACK FOOTER //
// ./src/util/cps/tools.js